module.exports = __webpack_public_path__ + "static/media/axa.5691cd14.png";